/**
 * Detects the visitor's country using the ipapi.co free API.
 * No API key required. Free tier: 1,000 requests/day.
 *
 * @returns {Promise<{ country: string, countryCode: string|null, currency: "NGN"|"USD" }>}
 */
export async function detectUserCountry() {
  try {
    const res = await fetch("https://ipapi.co/json/");
    if (!res.ok) throw new Error("Failed to fetch geolocation");
    const data = await res.json();

    const countryCode = data.country_code || null;
    const country = data.country_name || "";
    const currency = countryCode === "NG" ? "NGN" : "USD";

    return { country, countryCode, currency };
  } catch {
    // Fallback: unknown country, default to USD
    return { country: "", countryCode: null, currency: "USD" };
  }
}
